<div class="container">
  <div class="row">
    <div class="shadow-sm mb-0">
      <div class="">
        <div class="row justify-content-center">
          <div class="col-md-8 my-4">
            <p class="fs-6 text-center">
              Select the details icon next to a story to add the location, date,
              and category and tag people. Gray icons indicate that details need
              to be added for that story. Colored icons indicate that details
              have been successfully added.
            </p>
            <h2 class="title text-center my-4">My Brainstorms</h2>
            <div class="card">
              <div class="card-body">
                <table class="table table-centered table-hover">
                  <thead>
                    <tr>
                      <th class="w-25">Title</th>
                      <th class="w-25">Attachments</th>
                      <th class="w-25">Write</th>
                      <th class="w-25">Details</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let item of brainstorms; let i = index">
                    <tr>
                      <td class="align-middle">{{ item.title }}</td>
                      <td class="story-action-icon">
                        <button class="btn btn-primary">
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button class="btn btn-primary">
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button type="submit" class="btn btn-primary btn-edit">
                          <i class="fas fa-list-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <button class="btn btn-primary" type="submit" (click)="onSubmit()">
              Continue to step 6
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
